import { useEffect, useState } from "react";
import "./styles.css";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { useSpring, animated } from "@react-spring/web";
import { useNavigate } from "react-router-dom";
import { setAnimation } from "../redux/rootSlice";
import { AppPaths } from "../utils/AppPaths";
import StepOne from "../components/StepOne";
import { ReactComponent as StepOneMessage } from "../assets/message_svh_one.svg";
import TypeWriter from "../components/TypeWriter";

const OnBoardingOne = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [shouldRender, setShouldRender] = useState(false);
  const { step, isPopped } = useAppSelector(
    (state) => state.root
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldRender(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  const slidein = useSpring({
    from: { y: 500 },
    to: { y: 0 },
  });
  const springProps1 = useSpring({
    from: { marginRight: "20%" },
    to: { marginRight: "0%" },
    // loop: { reverse: true },
    config: { duration: 200 },
  });

  const popAnimation = useSpring({
    transform: isPopped ? "scale(1)" : "scale(0.9)",
    config: {
      duration: 100,
    },
  });

  const slideInAnimation = useSpring({
    opacity: shouldRender ? 1 : 0,
    transform: shouldRender ? "translateY(0%)" : "translateY(30%)",
    // config: {
    //   duration: 0,
    // },
  });

  useEffect(() => {
    if (step > 1) {
      springProps1.marginRight.start({
        from: { marginRight: "20%" },
        to: { marginRight: "0%" },
        // loop: { reverse: true },
        config: { duration: 200 },
      });
      setTimeout(() => {
        dispatch(setAnimation(true));
        slidein.y.start({
          from: { y: 500 },
          to: { y: 0 },
        });
      }, 200);
    } else {
      dispatch(setAnimation(true));
    }
  }, [dispatch, step]);

  const renderTopSvg = () => {
    return (
      <svg
        viewBox="0 0 375 454"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          // left: -10,
          // right: -10,
          // top: -32,
          zIndex: -1,
        }}
      >
        <path
          d="M-66 43L44.741 18.2962C142.95 -3.6119 244.864 -2.80936 342.716 20.6427L436 43"
          stroke="url(#paint0_linear_1102_5554)"
          stroke-width="270"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1102_5554"
            x1="16"
            y1="43"
            x2="363"
            y2="43"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9EEB" />
            <stop offset="0.145833" stop-color="#FF9728" stop-opacity="0.74" />
            <stop offset="0.302083" stop-color="#FFD203" stop-opacity="0.61" />
            <stop offset="0.510417" stop-color="#F1F232" stop-opacity="0.48" />
            <stop offset="0.65625" stop-color="#06AE56" stop-opacity="0.67" />
            <stop offset="0.859375" stop-color="#22A094" stop-opacity="0.77" />
            <stop offset="0.994236" stop-color="#91A8EC" />
          </linearGradient>
        </defs>
      </svg>
    );
  };

  const renderHeader = () => {
    return (
      <div className="mt-5 mx-5 flex flex-row items-center ">
        <img
          onClick={() => {
            navigate(AppPaths.SIGNUP);
          }}
          src={require("../assets/arrow-left.png")}
          className="arrow-left mr-2"
          alt=""
        />
        <div className="CountContainer rounded-2xl grid grid-row-1 gap-1 grid-flow-col relative ">
          <div
            // style={springProps2}
            className={`box box-1 flex flex-1  ${
              false && "bg-white"
            } rounded-l-2xl`}
          />
          <div
            // style={springProps2}
            className={`box box-2 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-3 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-4 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-5 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-6 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-7 flex flex-1  ${true && "bg-white"}`}
          />
          <div
            // style={springProps2}
            className={`box box-8 flex flex-1 ${
              step < 8 && "bg-white"
            }  rounded-r-2xl`}
          />
          {/* 
          <animated.div
            // style={springProps2}
            style={{ left: `${leftValue}vh` }}
            className="box absolute right-0 rounded-r-2xl bg-black"
          ></animated.div> */}
        </div>
      </div>
    );
  };

  const renderHeaderImage = () => {
    return (
      <span className="flex flex-1 justify-center relative">
        <img
          alt=""
          src={require("../assets/Item1.png")}
          className="onb1-2 inline-block mr-[-10px] mt-2"
        />
        <span className=" flex justify-center relative">
          <animated.div
            className="relative"
            style={{ ...springProps1, ...popAnimation }}
          >
            <div className="stepOnetext">
              <TypeWriter
                key={step}
                text="U4U is your home away from home."
                text2="What’s your dream home?"
                delay={40}
              />
            </div>
            <StepOneMessage />
          </animated.div>
        </span>
      </span>
    );
  };

  return (
    <div className="flex flex-col h-svh relative bg-white z-10">
      {renderTopSvg()}
      <div className="z-11">
        {renderHeader()}
        <div className="mt-3 mx-3">{renderHeaderImage()}</div>
      </div>
      <animated.div
        className="flex flex-col justify-center flex-1 py-4 overflow-y-auto mr-tp-1"
        // style={{ ...slideInAnimation, ...slidein }}
      >
        {shouldRender && <StepOne />}
      </animated.div>
    </div>
  );
};

export default OnBoardingOne;
